import { Loader2 } from 'lucide-react';

export function LoadingOverlay({ open, message = 'Loading...' }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="flex items-center gap-3 rounded-lg bg-white px-5 py-4 shadow-lg">
        <Loader2 className="h-5 w-5 animate-spin text-[#C97A5E]" />
        <span className="text-sm font-medium text-[#2D2420]">{message}</span>
      </div>
    </div>
  );
}
